<template>
	<div class="w-100">
		<v-list-item
			style=" min-height: 30px; min-width: 500px"
			class="overflow-x-auto"
			@click="open"
		>
			<v-row class="text-left">
				<v-col cols="7" md="8" style="min-width: 300px">
					<div>
						<v-icon class="mr-2" small :color="getStatusPerson(person)"
							>mdi-circle</v-icon
						>
						<v-badge
							color="error"
							:content="notified"
							:value="notified && !isShared"
							dot
						>
							{{ name(person.firstName, person.lastName) }}
						</v-badge>
						<span :class="[colorSubtitle]" class="caption"> {{ subtitle }}</span>
						<!-- <div :class="colorSubtitle" class="hidden-sm-and-up">{{ subtitle }}</div> -->
						<span v-if="person.geolocation && isInvite" class="caption text--secondary">
							<span class="hidden-sm-and-down">
								Última reporte de ubicación:
							</span>
							{{ getDate(person.geolocation.date) }}
						</span>
					</div>
				</v-col>
				<v-col class="text-right">
					<span>
						<!-- documento vencido -->
						<template v-if="itsDue">
							<v-tooltip right>
								<template v-slot:activator="{ on, attrs }">
									<span class="ma-2" v-on="on" v-bind="attrs">
										<v-icon color="warning">
											mdi-clock-alert
										</v-icon>
									</span>
								</template>
								<span>Tiene algun documento vencido</span>
							</v-tooltip>
						</template>
						<template
							v-else-if="
								person.typeDocument.length &&
									person.typeDocument.some(typeDocument => typeDocument)
							"
						>
							<!-- documento pendiente -->
							<template v-if="status">
								<v-tooltip right>
									<template v-slot:activator="{ on, attrs }">
										<span class="ma-2" v-on="on" v-bind="attrs">
											<v-icon color="warning">
												mdi-alert-circle
											</v-icon>
										</span>
									</template>
									<span>Documentos pendientes</span>
								</v-tooltip>
							</template>
							<!-- documento al dia -->
							<template v-else>
								<v-tooltip right>
									<template v-slot:activator="{ on, attrs }">
										<span class="ma-2" v-on="on" v-bind="attrs">
											<v-icon color="success">
												mdi-check-circle
											</v-icon>
										</span>
									</template>
									<span>Documentos al día</span>
								</v-tooltip>
							</template>
						</template>
					</span>
				</v-col>
			</v-row>
		</v-list-item>
		<v-bottom-sheet
			v-model="showBottomSheet"
			style=" position: relative;"
			scrollable
			inset
			@click:outside="close"
		>
			<v-card>
				<v-card-text style="height: max-content" class="px-1">
					<tabs :create="isCreated" :isInvite="isInvite" :isShared="isShared" />
					<person-unlink-button v-if="isShared" :person-id="person._id" />
					<v-btn
						v-if="!isShared"
						block
						class="my-4"
						color="accent"
						@click.stop="dialogConfirm = true"
					>
						{{ person.isUser ? 'Desvincular' : 'Eliminar' }}
					</v-btn>
					<dialog-confirm
						:title="`Estas seguro de ${person.isUser ? 'Desvincular' : 'Eliminar'}`"
						:dialog="dialogConfirm"
						:close="() => (dialogConfirm = false)"
						:confirm="() => unLink()"
						:loading="loading"
					/>
				</v-card-text>
			</v-card>
		</v-bottom-sheet>
		<v-divider />
	</div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapMutations } from 'vuex';

export default {
	name: 'PersonListItem',
	components: {
		DialogConfirm: () => import('@/components/ui/DialogConfirm'),
		PersonUnlinkButton: () => import('@/components/persons/PersonUnlinkButton'),
		Tabs: () => import('@/components/persons/Tabs'),
	},
	props: {
		person: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			showBottomSheet: false,
			dialogConfirm: false,
			loading: false,
		};
	},
	computed: {
		notified() {
			return this.person.conversation.some(
				item => !item.read && item.senderId !== this.userProfile._id
			);
		},
		colorSubtitle() {
			if (this.isInvite) {
				return 'primary--text';
			} else if (this.isShared) {
				return 'accent--text';
			}
			return 'success--text';
		},
		subtitle() {
			if (this.isInvite) {
				return '(Invitado)';
			} else if (this.isShared) {
				return '(Compartido)';
			}
			return '(Creado)';
		},
		isShared() {
			const authId = this.userProfile._id;
			const ownerId = this.person.ownerId ? this.person.ownerId : '';
			const sharedUsers = this.person.sharedUsers;
			return ownerId !== authId && sharedUsers.some(s => s === authId);
		},
		isCreated() {
			const ownerId = this.person.ownerId ? this.person.ownerId : '';
			return !this.person.isUser && ownerId === this.userProfile._id;
		},
		isInvite() {
			return this.person.isUser && this.person.idCompany === this.userProfile._id;
		},
		status() {
			return this.person.typeDocument.some(doc => doc && !doc.done);
		},
		itsDue() {
			return this.person.documents.some(doc => {
				if (doc !== null) return moment(doc.date).isBefore(moment().format());
			});
		},
	},
	methods: {
		open() {
			this.setPerson(this.person);
			this.setNotified(this.person.conversation);
			this.showBottomSheet = true;
		},
		close() {
			this.setPerson(null);
			this.showBottomSheet = false;
		},
		getDate(date) {
			return moment(date).fromNow();
		},
		getStatusPerson(person) {
			if (!person.documents.length && person.typeDocument.length) {
				return 'red';
			} else {
				if (this.itsDue) return 'orange';
				else if (
					person.typeDocument.length &&
					person.typeDocument.some(typeDocument => typeDocument)
				)
					return 'orange';
				else return 'green';
			}
		},
		name(name, lastname) {
			const text = `${name} ${lastname && this.$vuetify.breakpoint.mdAndUp ? lastname : ''}`;
			return text.toUpperCase();
		},
		async unLink() {
			this.loading = true;
			if (this.person.isUser) {
				await this.unlinkInvite(this.person._id);
				await this.getPersonsByAdmin();
			} else {
				await this.deletePerson(this.person._id);
				await this.getPersonsByAdmin();
			}
			this.loading = false;
			this.dialogConfirm = false;
		},
		...mapMutations({
			setPerson: 'Person/setPerson',
			setNotified: 'Person/setNotified',
		}),
		...mapActions({
			getPersonsByAdmin: 'Person/getPersonsByAdmin',
			deletePerson: 'Person/deletePerson',
			unlinkInvite: 'Person/unlinkInvite',
		}),
	},
	watch: {
		person(newValue, oldValue) {
			if (newValue && this.showBottomSheet) {
				this.setPerson(Object.assign(oldValue, { ...newValue }));
				this.setNotified(newValue.conversation);
			}
		},
	},
};
</script>
